<div class="container">
    <div id="home_nav" class="row">
        <div class="col-md-12">
            <ol class="breadcrumb loginMenu">
                <li class="breadcrumb-item">
                    <a class="bd-crumb-inactive" (click)="handleNavigation('home')">Home</a>
                </li>
                <li class="breadcrumb-item active" >Login</li>
            </ol>
        </div>
    </div>
    <div class="col-md-12" style="word-break: break-all;">
        <h3>{{loginMessage.loginPageMsg}}</h3>
    </div>
    <div class="row justify-content-md-center loginpanel">
        <div class="col-md-4 col-md-offset-4 lg-signBoxDiv">
            <div class="card login-card">
                <div class="card-header login-card-header">{{loginTitle}}</div>
                <div class="card-body login-card-body">
                    <form  (ngSubmit)="!loginForm.invalid && login()" #loginForm="ngForm">
                        <div *ngIf="isExtraLoginMessage" style="word-break: break-all;">
                            <label>{{extraLoginMessage}}</label>
                        </div>
                        <div *ngIf="showLoginImage">
                            <img class="login-img" src={{loginConfig.imageSource}} alt="noImage">
                        </div>   
                        <fieldset class="form-group">
                            <div>
                                <label for="username">{{loginConfig.userNameLabel}}</label>
                                <div class="input-group mb-3">
                                        <span class="input-group-text">
                                            <i class="fa fa-user" aria-hidden="true"></i>
                                        </span>
                                <input type="text" #username="ngModel" [(ngModel)]="model.username" class="input form-control" id="username" name="username" 
                                required="required" minlength="1" (click)=closeAlert()>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset class="form-group">
                            <div>
                                <label for="password">{{loginConfig.passwordLabel}}</label>
                                <div class="input-group mb-3">
                                        <span class="input-group-text"><i class="fa fa-lock" aria-hidden="true"></i></span>
                                    <input type="password" #password="ngModel" [(ngModel)]="model.password" id="password" name="password" 
                                    class="input form-control" required="required" minlength="1" (click)=closeAlert()>  
                                </div>                              
                            </div>
                        </fieldset>
                        <div class="row">
                        	<div *ngIf = "forgotPassword.link" class="col-sm-8 hover" style="color: #2196f3;" (click)=closeAlert()><a class="bd-crumb-inactive" [routerLink]="" (click)="handleNavigate(forgotPassword.link)">{{forgotPassword.label}}</a></div>
                            <div *ngIf = "!forgotPassword.link" class="col-sm-8 hover" style="color: #2196f3;" (click)=closeAlert()><a class="bd-crumb-inactive" [routerLink]="" (click)="handleNavigation('forgotPassword')">{{forgotPassword.label}}</a></div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 text-right d-flex justify-content-end">
                                <button type="submit button" class="btn btn-xs btn-light login-btn" [disabled]="loginForm.invalid">{{loginButtonLabel}}</button>
                            </div>
                        </div>
                        <div class="col-lg-16 col-md-16 col-xs-16 ">
                            <div>
                                {{logonBannerWarningMessage}}
                            </div>
                        </div>
                         <div>
                            <div *ngIf="loginIsvalid" class="alert alert-danger alertMessage">
                                {{loginAlertMessage}}
                            </div>
                            <span *ngIf="isSessionExceed && loginIsvalid">
                                <!-- <label class="alert alert-danger alertMessage"> {{'Force Logout from all other sessions ?'}}</label> -->
                                <button type="button" (click)="forceLogout()" class="py-1 my-1 btn btn-danger btn-sm">{{'Force Logout'}}</button>
                            </span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>